import { useEffect, useMemo } from 'react';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Grid } from '@mui/material';
import { useField } from 'formik';

import { useProductOrderContext } from 'src/contexts/ProductOrderProvider';

import OrderSumCard from '../OrderSumCard';

// TODO update this type when we have the products data
export type SelectedProducts = {
    primary: any[];
    secondary: any[];
};

interface ServiceOrdersProps {
    chargeableContractTerm: string | number;
    minimumContractTerm: string | number;
}
// chargeableContractTerm is used to calculate the total term without the Free months Promo
//  minimumContractTerm is used to display the contract term
const ServiceTotals = ({ chargeableContractTerm, minimumContractTerm }: ServiceOrdersProps) => {
    const [{ value: productOrder }] = useField('productOrder');
    const [_, __, { setValue: setTotals }] = useField('totals');
    const { order: contextOrder } = useProductOrderContext();

    const totals = useMemo(() => {
        let totalOneOff = 0;
        let totalMonthly = 0;

        if (contextOrder) {
            contextOrder.primaryProducts.forEach((product) => {
                totalOneOff += product.oneOffPrice * product.quantity;
                totalMonthly += product.monthlyPrice * product.quantity;
            });

            contextOrder.secondaryProducts.forEach((product) => {
                totalOneOff += product.oneOffPrice * product.quantity;
                totalMonthly += product.monthlyPrice * product.quantity;
            });
        } else {
            productOrder.primaryProducts.forEach((product) => {
                totalOneOff += product.oneOffPrice * product.quantity;
                totalMonthly += product.monthlyPrice * product.quantity;
            });

            productOrder.secondaryProducts.forEach((product) => {
                totalOneOff += product.oneOffPrice * product.quantity;
                totalMonthly += product.monthlyPrice * product.quantity;
            });
        }

        const termMonthlyTotal = Number(chargeableContractTerm) * totalMonthly;
        const totalTerm = termMonthlyTotal + totalOneOff;

        return { totalOneOff, totalTerm, totalMonthly };
    }, [
        contextOrder,
        chargeableContractTerm,
        productOrder.primaryProducts,
        productOrder.secondaryProducts,
    ]);

    useEffect(() => {
        setTotals(totals);
    }, [setTotals, totals]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
                <OrderSumCard
                    icon={<CalendarMonthIcon sx={{ color: '#FFFCF0' }} />}
                    title="Contract Term"
                    value={`${minimumContractTerm} Months` || 'N/A'}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrderSumCard
                    title="Total One-off"
                    value={totals?.totalOneOff || 0}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrderSumCard
                    title="Total Monthly"
                    value={totals?.totalMonthly || 0}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrderSumCard
                    title="Total Term"
                    value={totals?.totalTerm || 0}
                />
            </Grid>
        </Grid>
    );
};
export default ServiceTotals;
